export interface LoadingEndActionType {
  type: '@app/LOADING_END';
}

export const endLoading = (): LoadingEndActionType => ({
  type: '@app/LOADING_END',
});
